import { Button, InputGroup, Avatar, Pagination } from 'components/common';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import createMarkup from "helpers/createMarkup";
import { Link, useParams } from "react-router-dom";
import { calPaginatorRecord } from "helpers/paginator";
import { formatBookingDate, formatDateToWord, objectSerializer } from "helpers/utils";
import { FaSearch } from "react-icons/fa";
import { joinWithArray } from "helpers/utils";
import { getActivityLog } from "redux/crm/leadSlice";

import { INPUT_CLS as INPUT_CLASSES } from 'helpers/formStyles';
const LeadActivity = () => {
  const params = useParams()
  const leadId = params.id

  const [activities, setActivities] = useState([])
  const [paginate, setPaginate] = useState({
    totalRows: 0,
    totalPagesCount: 1,
    pageIndex: 1,
    pageSize: 20,
    from: 1,
    to: 20
  })
  const [filterValue, setFilterValue] = useState('')
  const [openStates, setOpenStates] = useState(Array(activities.length).fill(false));

  const dispatch = useDispatch()

  const emoji = '🕒'

  useEffect(() => {
    fetchActivityLog()
    // refetch on page/lead change only; filterValue is applied on search submit (handleSubmitSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, paginate.pageSize, paginate.pageIndex, dispatch])

  const fetchActivityLog = async () => {
    try {
      const params = {q: filterValue, page: paginate.pageIndex, per_page: paginate.pageSize}
      const response = await dispatch(getActivityLog({leadId, params}))

      const data          = response.payload
      const activeLogData = data.rows
      const total_rows    = data.total_rows

      setActivities(objectSerializer(activeLogData))

      const calRecords         = calPaginatorRecord(paginate.pageIndex, paginate.pageSize, total_rows)
      paginate.totalRows       = total_rows
      paginate.totalPagesCount = calRecords.totalPagesCount
      paginate.fromRecord      = calRecords.beginRecords
      paginate.toRecord        = calRecords.lastRecords
    }
    catch (error) {
      toast.error(error.message)
    }
  }

  const handlePageChange = ((page, pageSize) => {
    setPaginate({...paginate, pageIndex: page, pageSize: pageSize})
  })

  const handleSubmitSearch = (e) => {
    e.preventDefault()
    fetchActivityLog()
  }

  const toggleOpenState = (index) => {
    setOpenStates((prevOpenStates) => {
      const newOpenStates = [...prevOpenStates];
      newOpenStates[index] = !newOpenStates[index];
      return newOpenStates;
    });
  };

  return (
    <div className="tw-bg-white tw-rounded tw-shadow-sm tw-overflow-hidden">
      <div className="tw-bg-slate-50 tw-px-4 tw-py-3 tw-border-b tw-border-solid tw-border-slate-200">
        <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-items-center">
          <div className="tw-col-span-12 lg:tw-col-span-8">
            <h5 className="tw-mb-1 md:tw-mb-0 tw-font-semibold">Activities history</h5>
          </div>
          <div className="tw-col-span-12 lg:tw-col-span-4">
            <form onSubmit={handleSubmitSearch}>
              <InputGroup>
                <input
                  type="text"
                  placeholder="Search..."
                  className={INPUT_CLASSES}
                  onChange={(e) => setFilterValue(e.target.value)}
                />
                <Button size="sm" type="submit" variant="primary">
                  <FaSearch className="tw-mr-1" size={12} />
                  Search
                </Button>
              </InputGroup>
            </form>
          </div>
        </div>
      </div>
      <div className="tw-p-0">
        {activities && activities.map((activity, index) => {
          return (
            <div
              key={index}
              className="tw-border-b tw-border-solid tw-border-slate-200 last:tw-border-b-0"
            >
              <div className="notification tw-rounded-none">
                {activity.avatar && (
                  <div className="notification-avatar">
                    <Avatar {...activity.avatar} className="tw-mr-3" />
                  </div>
                )}
                <div className="notification-body">
                  <h6 className="tw-text-blue-600 tw-capitalize">{activity.action.replace(/_/g, ' ')}</h6>
                  <p className="tw-mb-1" dangerouslySetInnerHTML={createMarkup(activity.comment)} />
                  <span className="notification-time">
                    {emoji && (
                      <span className="tw-mr-2" role="img" aria-label="Emoji">
                        {emoji}
                      </span>
                    )}
                    {formatDateToWord(activity.created_at)} | by {activity.created_by}
                  </span>
                  {activity.audited_changes && Object.keys(activity.audited_changes).length !== 0 && (
                    <div className="tw-mt-2">
                      <Link onClick={() => toggleOpenState(index)}>
                        View Detail
                      </Link>
                      {openStates[index] && (
                        <div className="tw-border tw-border-solid tw-border-slate-200 tw-rounded-md">
                          <div className='tw-p-3'>
                            <div className="tw-overflow-x-auto">
                              <table className="tw-w-full tw-text-sm">
                                <thead className="tw-bg-blue-50 tw-text-center">
                                  <tr>
                                    <th scope="col" className="tw-text-left tw-py-2 tw-px-2">Attributes changed</th>
                                    <th scope="col" className="tw-text-left tw-py-2 tw-px-2">From</th>
                                    <th scope="col" className="tw-text-left tw-py-2 tw-px-2">To</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.entries(activity.audited_changes).map(([fieldName, fieldChanges], changeIndex)=> {
                                    const isDateField = fieldName === "Date of travel" || fieldName === "Date of return";
                                    const formatField = isDateField ? formatBookingDate : joinWithArray;

                                    return (
                                      <tr key={fieldName} className={changeIndex % 2 === 0 ? 'tw-bg-slate-50' : ''}>
                                        <td className="tw-text-left tw-py-2 tw-px-2">{fieldName}</td>
                                        <td className="tw-text-left tw-py-2 tw-px-2 tw-text-blue-600">
                                          {formatField(fieldChanges[0]) === true ? "true" : formatField(fieldChanges[0]) === false ? "false" : formatField(fieldChanges[0])}
                                        </td>
                                        <td className="tw-text-left tw-py-2 tw-px-2 tw-text-red-600">
                                          {formatField(fieldChanges[1]) === true ? "true" : formatField(fieldChanges[1]) === false ? "false" : formatField(fieldChanges[1])}
                                        </td>
                                      </tr>
                                    )
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}

        <div className="tw-m-3">
          <Pagination
            totalRows={paginate.totalRows}
            totalPagesCount={paginate.totalPagesCount}
            pageChange={handlePageChange}
            pageSize={paginate.pageSize}
            from={paginate.fromRecord}
            to={paginate.toRecord}
            itemsPages={["10", "20", "50"]}
          />
        </div>
      </div>
    </div>
  )
}

export default LeadActivity;
